const WarningDialog = {
  content: {
    title: 'Ops, Ocorreu um erro!',
    body: 'No momento, não há um boleto disponível para esta infração. Por favor, aguarde a disponibilização para poder informar um novo valor.'
  }
};

export default WarningDialog;
